import { assetUrl, withBase } from "../utils/sitePaths.js";

export default function ProductCard({ item }) {
  return (
    <article className="product-card">
      <img src={assetUrl(item.image)} alt={`${item.eyebrow} ingredient texture`} />
      <div>
        <p className="eyebrow">{item.eyebrow}</p>
        <h3>{item.title}</h3>
        <p>{item.description}</p>
        <dl>
          <div>
            <dt>Formats</dt>
            <dd>{item.formats}</dd>
          </div>
          <div>
            <dt>Applications</dt>
            <dd>{item.applications}</dd>
          </div>
        </dl>
        <a href={withBase("/contact")} className="text-link">
          Send inquiry
        </a>
      </div>
    </article>
  );
}
